import { render, staticRenderFns } from "./trigger.vue?vue&type=template&id=408f4e04&"
import script from "./trigger.vue?vue&type=script&lang=js&"
export * from "./trigger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports